/**
 * True when the quiz settings on the page differ from what the server has saved.
 * Only the settings the API stores in the quiz config are compared.
 */
export const hasUnsavedSettings = (quizObject, quizSettings) => {
  const saved = quizObject?.quizConfig

  // before the quiz and the page settings are loaded there is nothing to compare
  if (!saved || !quizSettings?.type) return false

  return (
    quizSettings.type.toLowerCase() !== (saved.type || '').toLowerCase() ||
    !!quizSettings.proctored !== !!saved.isProctored ||
    !!quizSettings.randomize !== !!saved.isRandomize ||
    !!quizSettings.result !== !!saved.showResult
  )
}

// the server keeps times as unix seconds, the page holds dates; both become whole seconds
const toSeconds = (value) => {
  if (value === null || value === undefined || value === '') return null

  const ms =
    typeof value === 'number' && Math.abs(value) < 1e11
      ? value * 1000
      : new Date(value).getTime()

  return Number.isNaN(ms) ? null : Math.floor(ms / 1000)
}

/**
 * True when the title, description, instructions, test window or duration on the page differ
 * from what the server has saved. A missing quizInfo.title means the title was not touched.
 */
export const hasUnsavedInfo = (quizObject, quizInfo, defaultInstructions) => {
  if (!quizObject?.info || !quizInfo) return false

  const text = (value) => (value ?? '').trim()
  const savedInstructions =
    text(quizObject.info.instructions) || defaultInstructions

  return (
    text(quizInfo.title ?? quizObject.info.title) !==
      text(quizObject.info.title) ||
    text(quizInfo.description) !== text(quizObject.info.description) ||
    text(quizInfo.instructions) !== text(savedInstructions) ||
    toSeconds(quizInfo.startTime) !== toSeconds(quizObject.time?.start) ||
    toSeconds(quizInfo.endTime) !== toSeconds(quizObject.time?.end) ||
    Number(quizInfo.duration) !== Number(quizObject.time?.duration)
  )
}
